import { render } from "./VariantItem.vue?vue&type=template&id=5add325e&scoped=true"
import script from "./VariantItem.vue?vue&type=script&lang=js"
export * from "./VariantItem.vue?vue&type=script&lang=js"

import "./VariantItem.vue?vue&type=style&index=0&id=5add325e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5add325e"]])

export default __exports__